import { AsyncReduxState } from '../types';

export const initialAsyncReduxState: AsyncReduxState = {
    isLoading: false,
    isSuccessful: false,
    error: '',
    statusCode: undefined,
};

